import React, { Component } from 'react';

class ContainerRight extends Component {
    constructor(props){
        super(props);
        this.state = {
            collRight: [
                {
                    id: 1,
                    subtitle: 'Chapter 5',
                    title: 'Control of Discrete Dynamic Systems',
                    text: 'This chapter covers the evolution of control theory and stability principles in discrete systems. Topics include step response, frequency-domain closed-loop design, and the fundamentals of MIMO systems.'
                },
                {
                    id: 2,
                    title: 'Adaptive Control and Advanced Techniques',
                    text: 'Control methods based on state feedback, nonlinear control under uncertainty, and modern strategies such as concurrent learning and adaptive control with stochastic parameter variations are presented.'
                },
                {
                    id: 3,
                    title: 'Practical Applications in MATLAB',
                    text: 'Includes MATLAB simulation examples to implement adaptive controllers and evaluate their performance in real scenarios, even in the presence of saturation and actuation errors.'
                }
            ]
            
        }
    }
    render() {
        return (
            <div className="chapter-list border-right-0">
                 {
                    this.state.collRight.map((data,i) => (
                        <div className="chapter-item" key={i}>
                            <h4><span>{data.subtitle} </span> {data.title}</h4>
                            <p>{data.text} </p>
                        </div>
                    ))
                }
            </div>
        );
    }
}

export default ContainerRight;
